import { action, computed, observable } from 'mobx';
import { supplierApi, supplierAccountApi } from '@link/supplier/services';
import {
  Supplier as ISupplier,
  AccountbaseSupplier
} from '@link/supplier/services/types';

export class ActivitySupplier {
  nextCursor = '';
  @observable accessor suppliers: Array<ISupplier> = JSON.parse('[]');
  @observable accessor currentActivitySupplier: AccountbaseSupplier | null =
    null;
  @observable accessor currentSupplierId = '';
  @observable accessor loading = false;

  @action
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  @action
  async fetchSuppliers() {
    const response = await supplierApi.listSuppliers({
      body: {
        cursor: this.nextCursor
      }
    });
    const { suppliers, nextCursor = '' } = response;
    if (suppliers) {
      this.addSuppliers(suppliers);
    }
    this.setCursor(nextCursor);
    if (nextCursor === '') {
      this.setLoading(false);
    }
    return response;
  }

  @action
  async fetchAllSuppliers() {
    if (!this.loaded) {
      this.setLoading(true);
      const { nextCursor } = await this.fetchSuppliers();
      if (nextCursor) {
        await this.fetchAllSuppliers();
      }
    }
  }

  @action
  async getActivitySupplier(supplierId: string) {
    if (!supplierId) return;
    if (this.currentActivitySupplier?.supplierId !== supplierId) {
      const response = await supplierAccountApi.getSupplierDetail({
        supplierId
      });
      if (response.supplier) {
        this.setCurrentActivitySupplier(response.supplier);
      }
    }
  }

  @action
  setCurrentActivitySupplier(supplier: AccountbaseSupplier) {
    this.currentActivitySupplier = supplier;
  }

  @action
  addSuppliers(suppliers: Array<ISupplier>) {
    this.suppliers = this.suppliers.concat(suppliers);
  }

  @action
  clearSuppliers() {
    this.suppliers = [];
    this.nextCursor = '';
  }

  @action
  setCursor(cursor: string) {
    this.nextCursor = cursor;
  }

  @action
  setSupplierId(supplierId: string) {
    this.currentSupplierId = supplierId;
  }

  @computed
  get supplierName() {
    return this.currentActivitySupplier?.originalName || '';
  }

  @computed
  get directPublish() {
    return this.currentActivitySupplier?.allowDirectPublish || false;
  }

  @computed
  get currentSupplier() {
    const supplier = this.suppliers.find(
      supplier => supplier.id === this.currentSupplierId
    );
    return supplier;
  }

  @computed
  get supplierOptions() {
    return this.suppliers.map(supplier => ({
      label: `${supplier.id} (${supplier.name})`,
      value: supplier.id || ''
    }));
  }
  @computed
  get loaded() {
    return this.suppliers.length > 0 && this.nextCursor === '';
  }
}

export default new ActivitySupplier();
